import { render, staticRenderFns } from "./ProjectSelection.vue?vue&type=template&id=9be4986c&scoped=true&"
import script from "./ProjectSelection.vue?vue&type=script&lang=js&"
export * from "./ProjectSelection.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSelection.vue?vue&type=style&index=0&id=9be4986c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be4986c",
  null
  
)

export default component.exports